import React, { useEffect, useState } from 'react';
import { getLocale } from '../lang/useLanguage';

const API = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? "http://localhost:8001"
  : `${window.location.protocol}//${window.location.hostname}/api`;

function getToken() {
  return localStorage.getItem('token') || localStorage.getItem('access_token') || '';
}

function Badge({ children, tone = 'gray' }) {
  const colors = {
    green: { bg: '#dcfce7', color: '#166534', border: '#86efac' },
    red: { bg: '#fee2e2', color: '#991b1b', border: '#fecaca' },
    yellow: { bg: '#fef9c3', color: '#854d0e', border: '#fde68a' },
    blue: { bg: '#dbeafe', color: '#1e40af', border: '#bfdbfe' },
    gray: { bg: '#f3f4f6', color: '#374151', border: '#e5e7eb' },
  };
  const c = colors[tone] || colors.gray;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 9px',
      borderRadius: 999,
      fontSize: 12,
      fontWeight: 700,
      background: c.bg,
      color: c.color,
      border: `1px solid ${c.border}`,
      whiteSpace: 'nowrap'
    }}>
      {children}
    </span>
  );
}

function fmtDate(v) {
  if (!v) return '—';
  try {
    return new Date(v.replace(' ', 'T')).toLocaleString(getLocale());
  } catch {
    return v;
  }
}




export default function EdgeManager() {
  const [devices, setDevices] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  async function apiGet(path) {
    const res = await fetch(`${API}${path}`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || data.error || 'İstek başarısız');
    return data;
  }

  async function loadDevices() {
    setLoading(true);
    setErr('');
    try {
      const data = await apiGet('/edge-manager/devices');
      const list = data.devices || [];
      setDevices(list);
      if (!selected && list.length) {
        setSelected(list[0].edge_id);
      }
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function loadDetail(edgeId) {
    if (!edgeId) return;
    setErr('');
    try {
      const data = await apiGet(`/edge-manager/devices/${encodeURIComponent(edgeId)}`);
      setDetail(data);
    } catch (e) {
      setErr(e.message);
    }
  }

  useEffect(() => {
    loadDevices();
    const timer = setInterval(loadDevices, 3000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadDetail(selected);
    const timer = setInterval(() => loadDetail(selected), 3000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const selectedEdge = detail?.edge || devices.find(d => d.edge_id === selected);
  const machines = detail?.machines || [];

  const onlineCount = devices.filter(d => Number(d.online) === 1).length;
  const machineCount = devices.reduce((sum, d) => sum + Number(d.machine_count || 0), 0);
  const queueTotal = devices.reduce((sum, d) => sum + Number(d.queue_count || 0), 0);

  return (
    <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, color: '#111827' }}>Edge Manager</h1>
          <div style={{ color: '#6b7280', marginTop: 6 }}>
            Fabrika içindeki Edge cihazları, bağlı makineler ve bağlantı durumları.
          </div>
        </div>
        <button
          onClick={() => { loadDevices(); loadDetail(selected); }}
          style={{
            border: '1px solid #d1d5db',
            background: '#fff',
            borderRadius: 10,
            padding: '10px 14px',
            cursor: 'pointer',
            fontWeight: 700
          }}
        >
          Yenile
        </button>
      </div>

      {err && (
        <div style={{
          background: '#fee2e2',
          color: '#991b1b',
          border: '1px solid #fecaca',
          padding: 12,
          borderRadius: 10
        }}>
          {err}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 14 }}>
        {[
          ['Toplam Edge', devices.length],
          ['Online Edge', onlineCount],
          ['Bağlı Makine', machineCount],
          ['Queue', queueTotal],
        ].map(([label, value]) => (
          <div key={label} style={{
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 14,
            padding: 18,
            boxShadow: '0 8px 20px rgba(15,23,42,0.04)'
          }}>
            <div style={{ fontSize: 12, color: '#6b7280', fontWeight: 700, textTransform: 'uppercase' }}>{label}</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: '#111827', marginTop: 8 }}>{value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '380px 1fr', gap: 16 }}>
        <div style={{
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 14,
          overflow: 'hidden'
        }}>
          <div style={{ padding: 16, borderBottom: '1px solid #e5e7eb', fontWeight: 800 }}>
            Edge Cihazları
          </div>

          {loading && <div style={{ padding: 16, color: '#6b7280' }}>Yükleniyor...</div>}

          {!loading && devices.length === 0 && (
            <div style={{ padding: 16, color: '#6b7280' }}>Kayıtlı Edge bulunamadı.</div>
          )}

          {devices.map(edge => {
            const active = selected === edge.edge_id;
            return (
              <button
                key={edge.edge_id}
                onClick={() => setSelected(edge.edge_id)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  border: 'none',
                  borderBottom: '1px solid #f3f4f6',
                  background: active ? '#eff6ff' : '#fff',
                  padding: 14,
                  cursor: 'pointer'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ fontWeight: 800, color: '#111827' }}>{edge.edge_name || edge.edge_id}</div>
                  <Badge tone={Number(edge.online) === 1 ? 'green' : 'red'}>
                    {Number(edge.online) === 1 ? 'Online' : 'Offline'}
                  </Badge>
                </div>
                <div style={{ marginTop: 5, color: '#6b7280', fontSize: 12 }}>{edge.edge_id}</div>
                <div style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <Badge tone="blue">{edge.machine_count || 0} makine</Badge>
                  <Badge tone={Number(edge.queue_count || 0) === 0 ? 'green' : 'yellow'}>
                    Queue {edge.queue_count || 0}
                  </Badge>
                </div>
                <div style={{ marginTop: 8, color: '#9ca3af', fontSize: 12 }}>
                  Son heartbeat: {fmtDate(edge.last_seen)}
                </div>
              </button>
            );
          })}
        </div>

        <div style={{
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 14,
          overflow: 'hidden'
        }}>
          {!selectedEdge ? (
            <div style={{ padding: 24, color: '#6b7280' }}>Edge seçiniz.</div>
          ) : (
            <>
              <div style={{ padding: 18, borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 12 }}>
                  <div>
                    <h2 style={{ margin: 0, color: '#111827' }}>{selectedEdge.edge_name || selectedEdge.edge_id}</h2>
                    <div style={{ color: '#6b7280', marginTop: 5 }}>{selectedEdge.edge_id}</div>
                  </div>
                  <Badge tone={Number(selectedEdge.online) === 1 ? 'green' : 'red'}>
                    {Number(selectedEdge.online) === 1 ? 'Online' : 'Offline'}
                  </Badge>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12, marginTop: 16 }}>
                  <Info label="Versiyon" value={selectedEdge.version || selectedEdge.agent_version || '—'} />
                  <Info label="Hostname" value={selectedEdge.hostname || '—'} />
                  <Info label="OS" value={selectedEdge.os_info || '—'} />
                  <Info label="Son Heartbeat" value={fmtDate(selectedEdge.last_seen)} />
                </div>
              </div>

              <div style={{ padding: 18 }}>
                <h3 style={{ marginTop: 0, color: '#111827' }}>Bağlı Makineler</h3>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                    <thead>
                      <tr style={{ background: '#f9fafb' }}>
                        <Th>Makine</Th>
                        <Th>Driver</Th>
                        <Th>Protocol</Th>
                        <Th>Durum</Th>
                        <Th>Bağlantı</Th>
                        <Th>Son Görülme</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {machines.map(m => (
                        <tr key={`${m.edge_node_id}-${m.machine_code}`} style={{ borderTop: '1px solid #f3f4f6' }}>
                          <Td>
                            <div style={{ fontWeight: 800 }}>{m.machine_name || m.machine_code}</div>
                            <div style={{ color: '#6b7280', fontSize: 12 }}>{m.machine_code}</div>
                          </Td>
                          <Td>{m.driver || '—'}</Td>
                          <Td>{m.protocol || '—'}</Td>
                          <Td>
                            <Badge tone={m.status === 'offline' ? 'red' : m.status === 'unknown' ? 'gray' : 'green'}>
                              {m.status || 'unknown'}
                            </Badge>
                          </Td>
                          <Td>
                            <Badge tone={m.connection_status === 'offline' ? 'red' : m.connection_status === 'online' ? 'green' : 'gray'}>
                              {m.connection_status || 'unknown'}
                            </Badge>
                          </Td>
                          <Td>{fmtDate(m.last_seen)}</Td>
                        </tr>
                      ))}
                      {machines.length === 0 && (
                        <tr>
                          <Td colSpan={12}>Bu Edge için makine kaydı bulunamadı.</Td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div style={{
      background: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: 12,
      padding: 12
    }}>
      <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 800, textTransform: 'uppercase' }}>{label}</div>
      <div style={{ marginTop: 6, color: '#111827', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</div>
    </div>
  );
}

function Th({ children }) {
  return <th style={{ textAlign: 'left', padding: 12, color: '#374151', fontSize: 12, textTransform: 'uppercase' }}>{children}</th>;
}

function Td({ children, colSpan }) {
  return <td colSpan={colSpan} style={{ padding: 12, color: '#111827', verticalAlign: 'middle' }}>{children}</td>;
}
